import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,

};

export const fetchJobFairList = createAsyncThunk(
    "fetchJobFairList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/jobfair/get-all-jobfair?page=${body.page}&search=${body.search}&city=${body.city}&state=${body.state}&startDate=${body.startDate}&endDate=${body.endDate}&resume=${body.resume}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);



export const JobFairSlice = createSlice({
    name: "JobFairSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchJobFairList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchJobFairList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(fetchJobFairList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

    },
});

export default JobFairSlice.reducer;
